import {
  Controls,
  ScaleBar,
  ZoomButtons,
  ZoomSlide,
} from "../reactOL/controls";
import { Layers } from "../reactOL/layers";
import { Map } from "../reactOL/map";
import { Size as olSize } from "ol/size";

import { useViewContext } from "../../context/View/ViewContext";

import OsmTileLayer from "./layers/OsmTileLayer";
import BoundarySelectionLayer from "./layers/BoundarySelectionLayer";
import { useRef, useState } from "react";
import DrawCustomBoundary from "./interractions/DrawCustomBoundary";
import { Interactions, ViewMoveEnd } from "../reactOL/interactions";
import MapContainer from "./MapContainer";
import Views from "./views/Views";
import GbCensusMapView from "./views/GbCensus/GbCensusMapView";
import PtBoundaryMapView from "./views/PtBoundaries/PtBoundaryMapView";
import InrixVolumeMapView from "./views/InrixVolume/InrixVolumeMapView";
import InrixAverageSpeedMapView from "./views/InrixAverageSpeed/InrixAverageSpeedMapView";
import RouteLineMapView from "./views/routeline/RouteLineMapView";
import OrderItemInrixVolumesMapView from "./views/OrderItem/InrixVolumes/OrderItemInrixVolumesMapView";
import useViewUrlSync from "../../hooks/useViewUrlSync";
import SatelliteSwitch from "./tools/SatelliteSwitch";

const BoundaryMap = () => {
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<olSize | undefined>(undefined);

  const { view, loading } = useViewContext();

  const { setViewUrl } = useViewUrlSync();

  return (
    <MapContainer showSpinner={loading} ref={mapContainerRef}>
      <Map view={view} size={size}>
        <Layers>
          <OsmTileLayer />
          <BoundarySelectionLayer
            mapContainerRef={mapContainerRef}
            setSize={setSize}
          />
        </Layers>
        <Views>
          <GbCensusMapView />
          <PtBoundaryMapView />
          <InrixVolumeMapView />
          <InrixAverageSpeedMapView />
          <OrderItemInrixVolumesMapView />
          <RouteLineMapView />
        </Views>
        <Interactions>
          <DrawCustomBoundary />
          <ViewMoveEnd onMoveEnd={setViewUrl} />
        </Interactions>
        <Controls>
          <ScaleBar />
          <ZoomButtons />
          <ZoomSlide />
          <SatelliteSwitch />
        </Controls>
      </Map>
    </MapContainer>
  );
};

export default BoundaryMap;
